import React from 'react'


export default ({ category = "User", action, label, value, noInteraction, isConversion, children, ...props }) => {

    const handleClick = () => {
        console.log("ga event fired", category, action, label, value)
        if (window?.gtag) {
            window.gtag('event', action, {
                'event_category': category,
                'event_label': label,
                'value': value,
            });
        }
    }

    return (
        <span onClick={() => handleClick()} {...props}>
            {children}
        </span>
    )
}